import React, { createContext, useReducer } from "react";
import AppReducer from "./AppReducer";

const initialState = {
  superstars: [
    {
      id: 1,
      name: "Dima Vishnevetsky",
      img: "/Dima.png",
      social: [
        {
          website: "https://www.dimshik.com/",
        },
        { twitter: "https://twitter.com/dimshik100?s=20" },
      ],
      bio:
        "Front-End Expert 💻 · Freelancer 🚀 · Public speaker 🗣 · Traveler 🌎 · Tech enthusiast 🙌 · Coffee lover ☕️ · Happily married ❤️ · Community Leader 💚 · Create beautiful things with CODE 🌈",
    },
    {
      id: 2,
      name: "Brad Traversy",
      img: "/Brad.png",
      social: [
        {
          website: "https://www.traversymedia.com/",
        },
        { youtube: "https://www.youtube.com/user/TechGuyWeb/featured" },
        { twitter: "https://twitter.com/traversymedia" },
      ],
      bio:
        "I have been a freelancer, worked for a company and a business owner, but I discovered my real passion is teaching web development & programming in a simple and understandable way. I now run the Traversy Media YouTube channel and sell online courses",
    },
    {
      id: 3,
      name: "Wes Bos",
      img: "/Wes.png",
      social: [
        {
          website: "https://wesbos.com/",
        },
        {
          youtube: "https://www.youtube.com/user/wesbos/featured",
        },
        { twitter: "https://twitter.com/wesbos" },
      ],
      bio:
        "I'm a full Stack JavaScript developer from Canada 🇨🇦. I create free + premium courses and do a twice-weekly podcast called Syntax.",
    },
    {
      id: 4,
      name: "Scott Tolinski",
      img: "/Scott.png",
      social: [
        {
          website: "https://www.scotttolinski.com/",
        },
        { youtube: "https://www.youtube.com/user/LevelUpTuts/featured" },
        { twitter: "https://twitter.com/stolinski" },
      ],
      bio:
        "Web Developer | Creator of Level Up Tutorials | Co-host of Syntax.fm | Father of 2 | Bboy | Robotops Crew | Youtuber | Tea Drinker | Tutorial Maker | Fan of physical activity | Former Music Major | Denverite | Michigander | Shaw Brothers Kung Fu Film Watcher | Handstander | Stretching enthusiast",
    },
    {
      id: 5,
      name: "Hemil Patel",
      img: "/Hemil.png",
      social: [
        {
          youtube: "https://www.youtube.com/user/techSithTube/featured",
        },
        { twitter: "https://twitter.com/techsith1" },
      ],
      bio: "I am a front-end programmer and I love JavaScript!",
    },
    {
      id: 6,
      name: "Shaun Pelling - The Net Ninja",
      img: "/Shaun.png",
      social: [
        {
          website: "https://www.thenetninja.co.uk/",
        },
        { youtube: "https://www.youtube.com/channel/UCW5YeuERMmlnqo4oq8vwUpg" },
        { twitter: "https://twitter.com/thenetninjauk?lang=en" },
      ],
      bio:
        "The Net Ninja (Shaun) is a front-end developer from the UK. He enjoys programming, travelling & playing odd musical instruments.",
    },
    {
      id: 7,
      name: "Mosh Hamedani",
      img: "/Mosh.png",
      social: [
        {
          website: "https://codewithmosh.com/",
        },
        {
          youtube: "https://www.youtube.com/user/programmingwithmosh/featured",
        },
        { twitter: "https://twitter.com/moshhamedani" },
      ],
      bio:
        "Hi! I am Mosh Hamedani and I help ambitious developers take their coding skills to the next level. Since I started teaching online 3 years ago, I’ve taught over 200,000 students in 192 countries and my YouTube channel has been watched 5.7 million times.",
    },
    {
      id: 8,
      name: "Colt Steele",
      img: "/Colt.png",
      social: [
        {
          youtube:
            "https://www.youtube.com/channel/UCrqAGUPPMOdo0jfQ6grikZw/featured",
        },
        { twitter: "https://twitter.com/codecolt" },
      ],
      bio:
        "Hi! I'm Colt. I'm a developer with a serious love for teaching. I've spent the last few years teaching people to program at 2 different immersive bootcamps where I've helped hundreds of people become web developers and change their lives. My graduates work at companies like Google, Salesforce, and Square.",
    },
    {
      id: 9,
      name: "Mattias Petter Johansson - mpj",
      img: "/Mattias.png",
      social: [
        {
          youtube:
            "https://www.youtube.com/channel/UCO1cgjhGzsSYb1rsB4bFe4Q/featured",
        },
        { twitter: "https://twitter.com/mpjme" },
      ],
      bio:
        "Creates Fun Fun Function, a YouTube show about programming. Previously hacking JavaScript at Spotify. Formerly responsible for the front-end of JayCut, an online video editor which was acquired by Blackberry, where I worked in a small team that built Story Maker.",
    },
    {
      id: 10,
      name: "Ben Awad",
      img: "/Ben.png",
      social: [
        {
          youtube: "https://www.youtube.com/user/99baddawg/featured",
        },
        { twitter: "https://twitter.com/benawad" },
      ],
      bio:
        "I'm a software developer who makes videos about React, React Native, GraphQL, Typescript, Node.js, PostgreSQL, Python, and all things coding.",
    },
    {
      id: 11,
      name: "Jeff Delaney",
      img: "/Jeff.png",
      social: [
        {
          website: "https://fireship.io/",
        },
        {
          youtube:
            "https://www.youtube.com/channel/UCsBjURrPoezykLs9EqgamOA/featured",
        },
        { twitter: "https://twitter.com/jeffdelaney23" },
      ],
      bio:
        "Jeff Delaney is a GoogleDevExpert for Firebase and the creator of AngularFirebase.com. When not writing code he is out seeking adventure with his wife, boys, and pug.",
    },
    {
      id: 12,
      name: "Maximilian Schwarzmüller",
      img: "/Maximilian.png",
      social: [
        {
          website: "https://academind.com/",
        },
        {
          youtube:
            "https://www.youtube.com/channel/UCSJbGtTlrDami-tDGPUV9-w/featured",
        },
        { twitter: "https://twitter.com/maxedapps" },
      ],
      bio:
        "When I started learning to code - around the age of 12 - there were little resources to be found. I explore HTML and JavaScript basically in a trial and error way and also by exploring the source code of websites I could visit via my 56k connection.",
    },
    {
      id: 13,
      name: "Kyle",
      img: "/Kyle.png",
      social: [
        {
          website: "https://courses.webdevsimplified.com/",
        },
        {
          youtube:
            "https://www.youtube.com/channel/UCFbNIlppjAuEX4znoulh0Cw/featured",
        },
        { twitter: "https://twitter.com/DevSimplified" },
      ],
      bio:
        "I teach web development in an easy to understand and beginner friendly way focusing on core concepts and best practices.",
    },
  ],
};

export const GlobalContext = createContext(initialState);

export const GlobalProvider = ({ children }) => {
  const [state] = useReducer(AppReducer, initialState);

  return (
    <GlobalContext.Provider
      value={{
        superstars: state.superstars,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
